import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectLocations = createFeatureSelector<any>('locations');

export const selectLocationsState = createSelector(
    selectLocations,
    (state: any) => state,
);
